<template>
  <div class="content2">
    <div class="head_title">
      <div class="title1">桔家云整装案例展示</div>
      <div class="title2">一次装修 一生朋友</div>
      <div class="Scribing"></div>
    </div>
    <div class="main">
      <ul>
        <li v-for="(item,index) in datas.list" :key="index" @click="toCasedetails(item.docid)">
          <div class="imgs">
            <img :src="item.mainpicmid" />
          </div>
          <div class="describe">
            <div style="margin:0 auto">
              <div class="describe_title">{{item.casetitle}}</div>
              <div class="describe_title2">{{item.casedescribe}}</div>
            </div>
          </div>
        </li> 
      </ul>
    </div>
    <router-link to="DecorationCase">
      <div class="Seemore">查看更多</div>
    </router-link>
  </div>
</template>
<script>
import Vue from "vue";
export default {
  data() {
    return {
      datas:''
    };
  },
  methods: {
     toCasedetails(itemid) {
      this.$router.push({ name: "Decorationdetails", query: { id: itemid } });
    },
     getdata: async function() {
      let data = {
       areatype: "全部",
      limit: 6,
      page: 1,
      plantype: "全部",
      roomtype: "全部",
      style: "全部"
      };
      let res = await this.exequy.Packagescreening(data);
      this.datas = res.data.page;
    },
  },
    created: async function() {
    let self = this;
    self.getdata();
  }
};
</script>
<style scoped>
.content2 {
  width: 100%;
  padding-top: 90px;
  background: #f4f4f4;
  overflow: hidden;
}
.head_title {
}
.title1 {
  width: 100%;
  text-align: center;
  font-size: 30px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 3px;
  color: #333333;
}
.title2 {
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 2px;
  color: #666666;
}
.Scribing {
  width: 50px;
  height: 6px;
  background-color: #bc001d;
  margin: 0 auto;
  margin-top: 20px;
}

.Seemore {
  width: 100px;
  height: 40px;
  line-height: 40px;
  font-size: 14px;
  color: #bc001d;
  border: solid 1px #bc001d;
  margin: 0 auto;
  margin-top: 60px;
  margin-bottom: 60px;
}
.main {
  width: 1280px;
  margin: 0 auto;
  margin-top: 50px;
}
.main ul {
  padding-bottom: 10px;
  width: 100%;
  overflow: hidden;
  padding-inline-start: 0px;
  margin-block-start: 0em;
  margin-block-end: 0em;
}
.main ul li {
  width: 410px;
  list-style: none;
  float: left;
  margin-left: 10px;
  margin-top: 10px;
  overflow: hidden;
}
.main ul li:hover {
   box-shadow: 10px 10px 10px rgba(0,0,0,.5);
}
.imgs {
  width: 410px;
  height: 280px;
}
.imgs img {
  width: 100%;
  height: 100%;
}
.describe {
  width: 410px;
  height: 90px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-items: center;
}
.describe_title {
  width: 313px;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 1px;
  color: #333333;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.describe_title2 {
  width: 362px;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 1px;
  color: #999999;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
